import React, { useEffect, useState } from 'react';
import { Grid, Typography, Box, Skeleton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { BarChart, CustomButtonGroup } from '../../../shared';
import { getPersonalPromotionChannelAffinity } from '../../../../redux/thunks/physicanTargetListAnalysisThunk';
import { actions } from '../../../../redux/reducers/physicianTargetListAnalysisReducer';
import {
    PREFERENCES,
    PERSONAL_PROMOTION_CHANNEL_CHART_OPTIONS,
    PERSONAL_PROMOTION_CHANNEL_CHART_SERIES,
} from './constants';

function PersonalPromotionChannelAffinity(props) {
    const {} = props;
    const dispatch = useDispatch();
    const { company } = useSelector(state => state.company);
    const { personalPromotionChannel } = useSelector(state => state.physicianTargetListAnalysis);
    const { selectedPreference, data, chartSeries, categories, isLoading } = personalPromotionChannel;
    const { setPersonalPromotionChannelPreference } = actions;

    useEffect(() => {
        if(company.id){
            dispatch(getPersonalPromotionChannelAffinity({companyId: company.id}))
        }
        
    },[company.id])

    return (
        <Box className="box-sizing-border-box br-16px border-1-gray">
            <Box className="flex-column padding-24px border-bottom-gray">
                <Box className="flex-column gap-24">
                    <Box>
                        <Typography className="text-lg-semi-bold gray-900">
                            Personal Promotion Channel Affinity
                        </Typography>
                    </Box>
                    <Box>
                        <CustomButtonGroup
                            data={PREFERENCES}
                            selected={selectedPreference}
                            handleClick={(option) => dispatch(setPersonalPromotionChannelPreference({preference: option}))}
                        />
                    </Box>
                </Box>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box className="padding-24px height-343px apexchart-horizontal-bar-chart">
                    {isLoading ? <Skeleton variant='rectangular' width={'100%'} height={300}/> :
                        <BarChart
                            chartOptions={
                                {
                                    ...PERSONAL_PROMOTION_CHANNEL_CHART_OPTIONS,
                                    xaxis: {
                                        ...PERSONAL_PROMOTION_CHANNEL_CHART_OPTIONS.xaxis,
                                        categories: categories,
                                    }
                                }
                            }
                            chartSeries={chartSeries}
                        />
                    }
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}

export default PersonalPromotionChannelAffinity;
